import { useQueryParams } from '../useQueryParams';

export const useStoreId = () => {
    const { storeId } = useQueryParams();

    return storeId;
};
